import { uniqBy } from 'lodash-es';
import { callApi } from 'utils/api';
import { channelModel } from 'common/api/models';
import { addHomeChannel } from 'utils/navigation-utils';
import { getI18nLng } from 'utils/i18n';

/**
 * @return {Promise<channelModel[]>}
 */
export const fetchChannelsApi = () => {
  const language = getI18nLng();

  return callApi(`channels?lang=${language}`)
    .then((channels) => uniqBy(channels, 'id')) // todo: remove after: https://jira.mi24.tv/browse/CT-1825
    .then((channels) => channels.map(channelModel))
    .then(addHomeChannel);
};
